import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  getChildrenRequest: [],
  getChildrenSuccess: ["children"],
  getChildrenFailure: ["error"], // Add error parameter
  resetData: [],
});

export const GetChildrenTypes = Types;
export const GetChildrenActions = Creators;
export default Creators;

export const INITIAL_STATE = Immutable({
  data: null,
  fetching: null,
  payload: null,
  success: null,
  error: null,
  children: null,
});

export const GetChildrenSelectors = {
  getData: (state: any) => state.getChildren.data,
  isFetching: (state: any) => state.getChildren.fetching,
  isSuccess: (state: any) => state.getChildren.success,
  hasError: (state: any) => state.getChildren.error,
  getChildren: (state: any) => state.getChildren.children,
  getPayload: (state: any) => state.getChildren.payload,
};

export const request = (state: any) => {
  const updateData = {
    fetching: true,
    success: null,
    error: null,
    payload: null,
  };
  
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { children } = action;
  return {
    ...state,
    fetching: false,
    success: true,
    error: false,
    children,
  };
};

export const failure = (state: any, action: any) => {
  const { error } = action;
  const updateData = {
    fetching: false,
    success: false,
    error: error || true, // Store actual error or fallback to true
    payload: null,
  };
  
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const resetData = (state: any) => {
  return state.merge ? state.merge(INITIAL_STATE) : INITIAL_STATE;
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_CHILDREN_REQUEST]: request,
  [Types.GET_CHILDREN_SUCCESS]: success,
  [Types.GET_CHILDREN_FAILURE]: failure,
  [Types.RESET_DATA]: resetData,
});
